import request from '@/utils/request'

// 根据案件ID获取代理人列表
export function getAgentsByCaseId(caseId) {
  return request.get(`/api/agent/list/${caseId}`)
}

// 新增代理人
export function createAgent(data) {
  return request.post('/api/agent', data)
}

// 编辑代理人
export function updateAgent(agentId, data) {
  return request.put(`/api/agent/${agentId}`, data)
}

// 删除代理人
export function deleteAgent(agentId) {
  return request.delete(`/api/agent/${agentId}`)
} 